import { render, staticRenderFns } from "./bullWiseSemenStock.vue?vue&type=template&id=2344a6f0&scoped=true&"
import script from "./bullWiseSemenStock.vue?vue&type=script&lang=js&"
export * from "./bullWiseSemenStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344a6f0",
  null
  
)

export default component.exports